<div class="screen">

  @if (!selectedAvis()) {

    <!-- ── Filtres sites ── -->
    <div class="cat-row" #catRow
      (mousedown)="onCatDown($event, catRow)"
      (mousemove)="onCatMove($event, catRow)"
      (mouseup)="onCatUp()"
      (mouseleave)="onCatUp()">
      <span class="cat-chip" [class.cat-chip--active]="selectedSite() === null" (click)="selectSite(null)">{{ 'mobileSimulator.avisPatient.allChip' | translate }}</span>
      @for (s of sites; track s) {
        <span class="cat-chip" [class.cat-chip--active]="selectedSite() === s" (click)="selectSite(s)">{{ s }}</span>
      }
    </div>

    <!-- ── Liste ── -->
    <div class="avis-list">
      @for (a of filteredAvis(); track a.id) {
        <div class="avis-card" [attr.data-note]="a.note >= 4 ? 'good' : a.note === 3 ? 'mid' : 'bad'" (click)="select(a)">
          <div class="avis-card-top">
            <div class="avis-stars">
              @for (s of filledStars(a.note); track s) {
                <svg width="12" height="12" viewBox="0 0 24 24" [attr.fill]="noteColor(a.note)"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
              }
              @for (s of emptyStars(a.note); track s) {
                <svg width="12" height="12" viewBox="0 0 24 24" fill="#E5E7EB"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
              }
            </div>
            <span class="avis-note-badge" [style.color]="noteColor(a.note)" [style.background]="noteBg(a.note)">{{ a.note }}/5</span>
          </div>
          <p class="avis-comment">{{ a.commentaire }}</p>
          <div class="avis-footer">
            <span class="avis-cat">{{ categorieLabel(a.categorie) }}</span>
            <span class="avis-meta">{{ a.date }} · {{ a.site }}</span>
          </div>
        </div>
      }
    </div>

  } @else {

    <!-- ── Détail ── -->
    <button class="back-row" (click)="backToList()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
      <span>{{ 'mobileSimulator.avisPatient.backToAll' | translate }}</span>
    </button>

    <div class="detail-card">

      <div class="detail-header">
        <div class="detail-score" [style.background]="noteBg(selectedAvis()!.note)">
          <span class="detail-num" [style.color]="noteColor(selectedAvis()!.note)">{{ selectedAvis()!.note }}</span>
          <span class="detail-denom" [style.color]="noteColor(selectedAvis()!.note)">/5</span>
        </div>
        <div class="detail-header-right">
          <div class="detail-stars">
            @for (s of filledStars(selectedAvis()!.note); track s) {
              <svg width="16" height="16" viewBox="0 0 24 24" [attr.fill]="noteColor(selectedAvis()!.note)"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
            }
            @for (s of emptyStars(selectedAvis()!.note); track s) {
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#E5E7EB"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
            }
          </div>
          <span class="detail-label" [style.color]="noteColor(selectedAvis()!.note)">{{ noteLabel(selectedAvis()!.note) }}</span>
        </div>
      </div>

      <p class="detail-comment">{{ selectedAvis()!.commentaire }}</p>

      <div class="detail-meta">
        <span class="detail-cat">{{ categorieLabel(selectedAvis()!.categorie) }}</span>
        <span class="detail-sep">·</span>
        <span class="detail-info">{{ selectedAvis()!.site }}</span>
        <span class="detail-sep">·</span>
        <span class="detail-info">{{ selectedAvis()!.date }}</span>
      </div>

    </div>

  }

</div>